'use client';
import { createContext, type ReactNode, useContext } from 'react';

const defaultValue = {
  editable: false,
  pressroomId: '',
  openEditHighlights: () => console.error('No provider for ReportEditableContext'),
};

const ReportEditableContext = createContext<{
  editable: boolean;
  monitorLink?: string;
  pressroomId?: string;
  openEditHighlights?: () => void;
}>(defaultValue);

export const ReportEditableContextProvider = ({
  children,
  editable,
  pressroomId,
  monitorLink,
  openEditHighlights,
}: {
  children: ReactNode;
  editable: boolean;
  monitorLink?: string;
  pressroomId?: string;
  openEditHighlights?: () => void;
}) => {
  return (
    <ReportEditableContext.Provider
      value={{
        editable,
        monitorLink,
        pressroomId,
        openEditHighlights,
      }}
    >
      {children}
    </ReportEditableContext.Provider>
  );
};

export const useReportEditable = () => {
  const context = useContext(ReportEditableContext);
  if (context === defaultValue) {
    throw new Error('useReportEditable must be used within a ReportEditableContextProvider');
  }
  return context;
};
